export default __webpack_public_path__ + "static/bg-clocks--mobile-bc514c349cae51abbe99378634238a89.jpg";